import React, { useState } from "react";
//import TituloCard from "../../atoms/titles/Titulo";
import "./card.scss";
import ModalMensajes from "../modals/modalMensajes/ModalMensajes";
import { getUrlAlcantara } from "../../services/IndemnizacionService";
import Logo from "../../../resources/img/icono-publicaciones.png";

const Indemnizacion = () => {
  // const [ setLoading] = useState(false);
  const [show, setShow] = useState({ mensaje: false });
  const [ setShowFeedback] = useState({ mensaje: false });
  // const [urlAlcantara, setUrlAlcantara] = useState(null);

  const handleEnviarAlcantara = () => {
    getUrlAlcantara().then((data) => {
      if (!data.toString().startsWith("Error")) {
        if (data.url !== null) {
          window.open(data.url);
          localStorage.setItem("urlAlcantara", JSON.stringify(data.url));
        }
        // setLoading(true);
      } else {
        setShowFeedback(true);
      }
    });
  } 

  const handleClose = (e) => {
    setShow(false);
  };
 

  return (
    <section className="temas">
      <div className="card-caja-mini temas card m-4 h-auto"
        onClick={handleEnviarAlcantara}
        tabIndex={0}
        role="button"
        title="Solicitar Comisión de servicio"
        aria-label="Comisión de servicio"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            handleEnviarAlcantara()
          }
        }}
        >

        <div className="tituloAccesibilidad d-flex align-items-center">
          <img

            alt="C.S Indemnización razón servicio D.287/2007"
            src={Logo}
          />
          <h3 className="tituloAccesibilidad ms-2">C.S Indemnización razón servicio D.42/2025</h3>
        </div>

        <span className="ms-4">Solicitar Comisión de servicio.</span>
        {/* {loading ? null : (
          <>
            {showFeedback ? (
              <div className="pt-2 d-flex align-items-center flex-column">
                <p className="text-danger">
                  Error: No se ha podido conectar con el servidor. Intentelo más
                  tarde.
                </p>
              </div>
            ) : (
              <div className=" col-3 col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                <Placeholder></Placeholder>
              </div>
            )}
          </>
        )} */}

        {show.mensaje ? (
          <ModalMensajes
            show={show.mensaje}
            handleClose={handleClose}
            titulo={show.titulo}
            tipo={show?.tipo}
            destinoCerrar={handleClose}
          ></ModalMensajes>
        ) : null}
      </div>
    </section>
  );
};
export default Indemnizacion;
